import { Link } from "react-router-dom";

export const Navbrand = () => {
    return (
        <Link className="brand" to="/" title="Pela Fresta da Porta, por Luiz Lopes">
            <div className="brand-title">Pela Fresta da Porta</div>
            <div className="brand-subtitle">por Luiz Lopes</div>
        </Link>
    );
}